import { HStack, Input, useToast, VStack, OrderedList, ListItem } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import CDS from "design-system";
import { PrimaryButton } from "components/Button";
import apiClient from "services/ApiClient";
import { useCallback } from "react";
import ContentContainerBox from "components/ContentContainerBox";

export default function ImportMeetingForm({
  onComplete,
}: {
  onComplete: ({ templateId }: { templateId: string }) => void;
}) {
  const toast = useToast();
  const mutation = useMutation({
    mutationFn: async (data: { meetingUrl: string }) => {
      const result = await apiClient.post<{ templateId: string; id: string }>("api/meetings/import", data);
      return result;
    },
    onSuccess: (data) => onComplete({ templateId: data.templateId }),
    onError: (error) =>
      toast({
        title: "Error",
        description: error.message,
        status: "error",
      }),
  });
  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      mutation.mutate({ meetingUrl: event.target.meetingUrl.value });
    },
    [mutation],
  );

  return (
    <VStack align="start" spacing="32px" width="100%" pb="16px">
      <ContentContainerBox>
        <VStack align="start" spacing="8px" fontSize="12px">
          <CDS.Text12 fontWeight="semibold">Instructions:</CDS.Text12>
          <OrderedList spacing="2px" pl="8px">
            <ListItem>Open Google Calendar and find the event you want to import</ListItem>
            <ListItem>Click on the event, then click the edit button (pencil icon)</ListItem>
            <ListItem>Copy the URL from your browser&apos;s address bar</ListItem>
            <ListItem>Paste the URL below and click &quot;Import meeting&quot;</ListItem>
          </OrderedList>
        </VStack>
      </ContentContainerBox>

      <HStack as="form" onSubmit={handleSubmit} spacing="8px" width="100%" alignItems="stretch">
        <Input
          type="url"
          placeholder="Paste your Google Calendar link here"
          variant="outline"
          name="meetingUrl"
          borderWidth="1px"
          borderColor="chakra-border-color"
          required
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
        <PrimaryButton size="md" type="submit" isLoading={mutation.isPending} px="24px">
          Import meeting
        </PrimaryButton>
      </HStack>
    </VStack>
  );
}
